import { Button, Checkbox, Form, Input, message, Select } from 'antd';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { IconCopy } from '../../../assets/index';
import BreadCrumbComponent from '../../../components/breadcrumb/BreadCrumbComponent';
import useTextLink from '../../../hooks/useTextLink';
import { routes } from '../../../utils/constants/constant';
import { isEmpty } from '../../../utils/helpers/helpers';
import './TextLink.scss';

const breadCrumbs = [
  {
    name: 'Trang chủ',
    isLink: false,
  },
  {
    name: 'Tổng quan',
    isLink: true,
    link: routes.DASHBOARD,
  },
  {
    name: 'Text Links',
    isLink: false,
  },
];
const { Option } = Select;
const TextLink = (props) => {
  const { onFinishFailed, onFinish, url, setUrl, listDomain, form } =
    useTextLink({ ...props });
  return (
    <div className='container'>
      <BreadCrumbComponent breadCrumbs={breadCrumbs} />
      <div className='title-container'>Text Links</div>
      <div className='title-text-link'>
        Chèn link liên kết trong nội dung của bạn để chuyển hướng người đọc đến
        trang hay hoạt động cụ thể trên Mytour - khiến người đọc tập trung vào
        nội dung văn bản của bạn.
      </div>
      <div className='content'>
        <Form
          form={form}
          name='basic'
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          layout='vertical'
          initialValues={{
            campaignName: undefined,
            affiliationDomainId: undefined,
            isCheckSpecificLink: false,
            specificLink: undefined,
          }}
        >
          <div className='input-website'>
            <Form.Item
              label='Tên chiến dịch'
              name='campaignName'
              rules={[
                { required: true, message: 'Vui lòng nhập tên chiến dịch' },
              ]}
            >
              <Input
                placeholder='Nhập Tên chiến dịch'
                onChange={({ target: { value } }) => {
                  setUrl('');
                }}
              />
            </Form.Item>
          </div>
          <div className='input-website'>
            <Form.Item
              name='affiliationDomainId'
              label='Nền tảng'
              className='select-domain'
              rules={[{ required: true, message: 'Vui lòng chọn nền tảng' }]}
            >
              {!isEmpty(listDomain) && (
                <Select
                  onChange={() => {
                    setUrl('');
                  }}
                >
                  {listDomain?.map((el) => (
                    <Option value={el.id}>{el.domain}</Option>
                  ))}
                </Select>
              )}
            </Form.Item>
          </div>
          <Form.Item
            shouldUpdate={(prevValues, curValues) =>
              prevValues.affiliationDomainId !== curValues.affiliationDomainId
            }
            className='request-image-item'
          >
            {() => (
              <>
                {listDomain.find(
                  (el) => el.id === form.getFieldValue('affiliationDomainId')
                )?.allowSpecificLink && (
                  <>
                    <div className='input-website'>
                      <Form.Item
                        name='isCheckSpecificLink'
                        className='is-check-specific-link'
                        valuePropName='checked'
                      >
                        <Checkbox
                          onChange={() => {
                            setUrl('');
                          }}
                        >
                          Đường dẫn trực tiếp tới sản phẩm
                        </Checkbox>
                      </Form.Item>
                    </div>
                    <Form.Item
                      shouldUpdate={(prevValues, curValues) =>
                        prevValues.isCheckSpecificLink !==
                        curValues.isCheckSpecificLink
                      }
                      className='request-image-item'
                    >
                      {() => (
                        <>
                          {form.getFieldValue('isCheckSpecificLink') && (
                            <div className='input-website'>
                              <Form.Item
                                name='specificLink'
                                className='specific-link'
                                rules={[
                                  {
                                    required: form.getFieldValue(
                                      'isCheckSpecificLink'
                                    ),
                                    message:
                                      'Vui lòng nhập đường dẫn trực tiếp tới sản phẩm',
                                  },
                                ]}
                              >
                                <Input
                                  placeholder='Ví dụ: https://mytour.vn/khach-san/1223-khach-san-sofitel-plaza-sai-gon...'
                                  onChange={({ target: { value } }) => {
                                    setUrl('');
                                  }}
                                />
                              </Form.Item>
                            </div>
                          )}
                        </>
                      )}
                    </Form.Item>
                  </>
                )}
              </>
            )}
          </Form.Item>

          <Form.Item>
            <Button className='submit-save' htmlType='submit'>
              <span>Lưu và tạo mã</span>
            </Button>
          </Form.Item>
        </Form>
        {url && (
          <div className='content-url'>
            <div className='content-url-header'>
              <span>URL</span>
              <span
                className='wrap-copy'
                onClick={() => {
                  navigator.clipboard.writeText(url);
                  message.success('Sao chép mã thành công!');
                }}
              >
                <div className='icon-copy'>
                  <IconCopy />
                </div>
                Sao chép mã
              </span>
            </div>
            <div className='url'>{url}</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default connect(
  (state) => ({
    profile: state.systemReducer.profile,
    generalInfo: state.systemReducer.generalInfo,
  }),
  {}
)(withRouter(TextLink));
